import { Backdrop, CircularProgress, Container } from '@mui/material';
import React from 'react';
import FAQ from '../components/Support/FAQ';
import SupportCard from '../components/Support/SupportCard';
import { useGetPublic } from '../lib/api/hooks';
import { EMPTY_GUID } from '../lib/constants/misc';
import { SupportDataDto } from '../lib/models/SupportModels';
import { backdropStyle } from '../style';

const SupportPage = () => {
    const { data, loading } = useGetPublic<SupportDataDto>(
        'Support/GetAllSupportInformationsAsync'
    );

    return (
        <Container
            maxWidth="lg"
            sx={{
                pt: '1.875rem'
            }}>
            {!loading ? (
                data && (
                    <>
                        {(data.clinicalSupport && <SupportCard {...data.clinicalSupport} />) ?? (
                            <SupportCard
                                type={'Clinical'}
                                availability={''}
                                supportContact={[]}
                                id={EMPTY_GUID}
                            />
                        )}
                        {(data.technicalSupport && <SupportCard {...data.technicalSupport} />) ?? (
                            <SupportCard
                                type={'Technical'}
                                availability={''}
                                supportContact={[]}
                                id={EMPTY_GUID}
                            />
                        )}
                        {(data.frequentlyAskedQuestion && (
                            <FAQ faqs={data.frequentlyAskedQuestion} />
                        )) ?? <FAQ faqs={[]} />}
                    </>
                )
            ) : (
                <>
                    <Backdrop sx={backdropStyle} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </>
            )}
        </Container>
    );
};

export default SupportPage;
